import { round } from 'lodash';

export default (value: number, precision: number | undefined) =>
  round(value, precision).toFixed(precision);
